import type { CSSProperties } from "react";

const PALETTE: Record<string, CSSProperties> = {
  AVAILABLE: { backgroundColor: "#2e7d32", color: "#ffffff" },
  PARTIALLY_AVAILABLE: { backgroundColor: "#0077b6", color: "#ffffff" },
  CHARGING: { backgroundColor: "#6b7280", color: "#ffffff" },
  OCCUPIED: { backgroundColor: "#3949ab", color: "#ffffff" },
  RESERVED: { backgroundColor: "#7e57c2", color: "#ffffff" },
  TIME_OUT: { backgroundColor: "#ef6c00", color: "#ffffff" },
  OUT_OF_ORDER: { backgroundColor: "#d32f2f", color: "#ffffff" },
  REMOVED: { backgroundColor: "#37474f", color: "#ffffff" },
};

const UNKNOWN: CSSProperties = { backgroundColor: "#e5e7eb", color: "#111827" };

/** Colour for a user-facing status. Unrecognised values get a neutral chip rather than vanishing. */
export const statusStyle = (status: string | null | undefined): CSSProperties =>
  PALETTE[String(status ?? "").trim().toUpperCase()] ?? UNKNOWN;

export const KNOWN_STATUS_COLOURS = PALETTE;
